import React, {useEffect, useState} from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import {Feedbacks} from "../Utils/Feedbacks";

const responsive = {
    0: {items: 1},
    860: {items: 2},
    1440: {items: 3},
};

const createItems = (array, [handleClick]) => {
    let deltaX = 0;
    let difference = 0;
    const swipeDelta = 20;

    return array.map((item, i) => (
        <div key={`project-${item.id}`} className="carousel-center">
            <div className="feedback-card"

                 data-value={i + 1}
                 onMouseDown={(e) => (deltaX = e.pageX)}
                 onMouseUp={(e) => (difference = Math.abs(e.pageX - deltaX))}
                 onClick={() => (difference < swipeDelta) && handleClick(i)}
            >
                <div className="stars">
                    {[...Array(item.stars)].map((star, index) => {
                        index += 1;
                        return (
                            <img key={index} alt="star"
                                 src={require("../Assets/Images/star.svg").default}
                            />
                        );
                    })}
                </div>
                <div className="feedback-message">{item?.message}</div>
                <div className="feedback-user">
                    <img className="feedback-avatar" alt="avatar"
                         src={require("../Assets/Images/user_photo.svg").default}
                    />
                    <div className="feedback-user-details">
                        <div className="feedback-name">{item?.name}</div>
                        <div className="feedback-profession">{item?.profession}</div>
                    </div>
                </div>
            </div>
        </div>
    ));
};

export const Carousel = () => {
    const [matches, setMatches] = useState(
        window.matchMedia("(max-width: 850px)").matches
    );

    useEffect(() => {
        window
            .matchMedia("(max-width: 850px)")
            .addEventListener('change', e => setMatches(e.matches));
    })

    const [activeIndex, setActiveIndex] = useState(0);
    const [items] = useState(createItems(Feedbacks, [setActiveIndex]));

    const slidePrev = () => setActiveIndex(activeIndex - 1);
    const slideNext = () => setActiveIndex(activeIndex + 1);
    const syncActiveIndex = ({item}) => setActiveIndex(item);

    return [
        <div className="carousel-wrap">
            <AliceCarousel
                mouseTracking
                disableDotsControls={!matches}
                disableButtonsControls
                items={items}
                activeIndex={activeIndex}
                responsive={responsive}
                onSlideChanged={syncActiveIndex}
            />
            {!matches ?
                <div className="b-refs-buttons">
                    <button onClick={slidePrev}>
                        <img alt="arrow-prev" src={require("../Assets/Images/arrow-prev.svg").default}/>
                    </button>
                    <button onClick={slideNext}>
                        <img alt="arrow-next" src={require("../Assets/Images/arrow_next.svg").default}/>
                    </button>
                </div>
                :
                null
            }
        </div>
    ];
};